import React from 'react';
import { CallId } from 'shared/models';
import { VideoCallRecord } from '../videoCallRecord/VideoCallRecord';
import { animated, useSprings } from 'react-spring';
import { NoVideoCalls } from '../noVideoCalls/NoVideoCalls';

require('./VideoCallRecordSet.css');

export type Props = {
    callIds: CallId[];
    type: 'active' | 'pending' | 'recent';
};

export const VideoCallRecordSet = (props: Props) => {
    const { callIds, type } = props;

    const [ springs ] = useSprings(callIds.length, () => ({
        from: {
            opacity: 0,
        },
        opacity: 1,
    }));

    return (
        <div className="vcrs">
            { springs.length === 0 &&
                <NoVideoCalls type={ type }/>
            }
            { springs.map((style, i) =>
                <animated.div
                    className="vcr-host"
                    style={ style }
                    key={ callIds[i] }
                >
                    <VideoCallRecord
                        callId={ callIds[i] }
                    />
                </animated.div>
            ) }
        </div>
    );
};
